import React, { useEffect, useState } from "react";
import { object, string, bool } from "prop-types";
import { ReadMoreToggle } from "../../atoms";

import "./text-with-read-more.m.css";

const charLimits = {
  desktop: 180,
  tablet: 160,
  mobile: 110,
};
const magCharLimits = {
  ...charLimits,
  mobile: 110,
};

export const TextWithReadMore = ({ textElement, deviceType, isMagazine = false, storyHeader = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [plainText, setPlainText] = useState("");
  const [shouldShowReadMore, setShouldShowReadMore] = useState(false);
  const charLimit = isMagazine ? magCharLimits[deviceType] : charLimits[deviceType];

  /*useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = textElement.text;
      const textContent = tempDiv.innerText || tempDiv.textContent;
      setPlainText(textContent);
      setShouldShowReadMore(textContent.length > charLimit);
    }
    const element = document.getElementById("story-header-readmore");
    if (element) {
      element.className = "";
    }
  }, [textElement, charLimit]);*/

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const endString = shouldShowReadMore ? "..." : "";
  //const truncatedHTML = isExpanded ? textElement.text : plainText.slice(0, charLimit) + endString;
  const truncatedHTML = textElement.text;

  return (
    <div styleName={`text-container ${isExpanded ? "expanded" : ""}`}>
      <span
        {...(storyHeader ? { id: "story-header-readmore" } : {})}
        //styleName={`${storyHeader ? "story-header-readmore" : ""}`}
        dangerouslySetInnerHTML={{ __html: storyHeader ? truncatedHTML || textElement.text : truncatedHTML }}
      />
      {shouldShowReadMore && (
        <ReadMoreToggle textElement={textElement} isExpanded={isExpanded} onClick={toggleDescription} />
      )}
    </div>
  );
};

TextWithReadMore.propTypes = {
  textElement: object,
  deviceType: string,
  storyHeader: bool,
};
